// src/pages/Parametros/tabs/TabCrescimento.jsx
import React from 'react';
import {
    Box, TextField, Switch, FormControlLabel,
    Typography, Paper, Select, MenuItem,
    FormControl, InputLabel, InputAdornment,
} from '@mui/material';
import { useParametrosAnalise } from '../../../context/ParametrosAnaliseContext';

export default function TabCrescimento() {
    const { params, updateGroup } = useParametrosAnalise();
    const c = params.crescimento;
    const set = (field, value) => updateGroup('crescimento', { [field]: value });

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 3 }}>
            <Paper variant="outlined" sx={{ p: 3 }}>
                <Typography variant="subtitle1" fontWeight={600} mb={2}>
                    Modo de detecção
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                    <FormControl sx={{ width: 240 }}>
                        <InputLabel>Modo de análise</InputLabel>
                        <Select
                            value={c.modoAnalise}
                            label="Modo de análise"
                            onChange={(e) => set('modoAnalise', e.target.value)}
                        >
                            <MenuItem value="presence_absence">presence_absence</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={c.ativarDetectorCombinado}
                                onChange={(e) => set('ativarDetectorCombinado', e.target.checked)}
                            />
                        }
                        label="Ativar detector combinado (AmplitudeDetector + RatioDetector + DerivativeDetector)"
                    />
                </Box>
            </Paper>

            <Paper variant="outlined" sx={{ p: 3 }}>
                <Typography variant="subtitle1" fontWeight={600} mb={2}>
                    Consenso e limites de série
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                    <TextField
                        label="Consenso mínimo entre detectores"
                        type="number"
                        value={c.percentualMinimoConsenso}
                        onChange={(e) => set('percentualMinimoConsenso', Number(e.target.value))}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                        }}
                        inputProps={{ min: 1, max: 100 }}
                        sx={{ width: 260 }}
                        helperText="≥50% → presença confirmada"
                    />
                    <TextField
                        label="Mínimo de pontos por série"
                        type="number"
                        value={c.minimosPontosPorSerie}
                        onChange={(e) => set('minimosPontosPorSerie', Number(e.target.value))}
                        inputProps={{ min: 1 }}
                        sx={{ width: 220 }}
                        helperText="Amplitude/Ratio exigem ≥5; Derivativo exige ≥10"
                    />
                </Box>
            </Paper>

            <Paper variant="outlined" sx={{ p: 3 }}>
                <Typography variant="subtitle1" fontWeight={600} mb={2}>
                    Pré-processamento (smoothing)
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                    <TextField
                        label="Janela moving average"
                        type="number"
                        value={c.tamanhoJanelaMovingAverage}
                        onChange={(e) => set('tamanhoJanelaMovingAverage', Number(e.target.value))}
                        inputProps={{ min: 1 }}
                        sx={{ width: 220 }}
                        helperText="Pontos (padrão: 20)"
                    />
                    <TextField
                        label="Sigma smoothing"
                        type="number"
                        value={c.sigmaSmoothing}
                        onChange={(e) => set('sigmaSmoothing', Number(e.target.value))}
                        inputProps={{ min: 0, step: 0.1 }}
                        sx={{ width: 180 }}
                    />
                    <FormControl sx={{ width: 200 }}>
                        <InputLabel>Direção esperada</InputLabel>
                        <Select
                            value={c.direcaoEsperada}
                            label="Direção esperada"
                            onChange={(e) => set('direcaoEsperada', e.target.value)}
                        >
                            <MenuItem value="auto">auto</MenuItem>
                            <MenuItem value="up">up</MenuItem>
                            <MenuItem value="down">down</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            </Paper>
        </Box>
    );
}
